export default __webpack_public_path__ + "static/media/pic11.9e8e8227.png";